export const DEFAULT_AUTOFIX_TEMPLATE = `Build failed. Please investigate and fix the issue.

App: {{app_name}}
Project: {{project_path}}
Ref: {{ref}}
Job: {{job_name}} (id {{job_id}})
Job URL: {{job_url}}

{{job_log}}`;

export const TOOL_SCOPES = [
  { value: 'logs:read', label: 'Raw logs', kind: 'read' },
  { value: 'logs:query', label: 'Structured log query', kind: 'read' },
  { value: 'logs:detail', label: 'Structured log detail', kind: 'read' },
  { value: 'pipelines:read', label: 'Pipeline list', kind: 'read' },
  { value: 'pipelines:jobs:read', label: 'Pipeline jobs', kind: 'read' },
  { value: 'pipelines:logs:read', label: 'Pipeline job logs', kind: 'read' },
  { value: 'pipelines:artifacts:read', label: 'Pipeline job artifact files', kind: 'read' },
  { value: 'pipelines:play', label: 'Play manual job', kind: 'action' },
  { value: 'pipelines:play:*', label: 'Deploy stages', kind: 'action' },
  { value: 'context:read', label: 'Conversation context', kind: 'read' },
  { value: 'activities:read', label: 'Turn activities', kind: 'read' },
  { value: 'resources:read', label: 'Read private resources and priorities', kind: 'coordination' },
  { value: 'resources:write', label: 'Coordinate resource requests and handoffs', kind: 'coordination' },
  { value: 'resources:manage', label: 'Manage resource priorities and executor limits', kind: 'action' },
  { value: 'cloud:read', label: 'Read private Codex Cloud conversations', kind: 'action' },
  { value: 'cloud:control', label: 'Send and steer Codex Cloud turns (subscription usage)', kind: 'action' },
  { value: 'backups:read', label: 'Read private backup archive metadata', kind: 'action' },
  { value: 'backups:archive', label: 'Archive private backups to approved storage', kind: 'action' },
  { value: 'backups:restore', label: 'Verify private archives with an isolated restore', kind: 'action' },
  { value: 'backups:retire', label: 'Retire native backup copies after verified recovery', kind: 'action' },
  { value: 'ui-validation:read', label: 'Managed UI validation', kind: 'read' },
  { value: 'ui-validation:run', label: 'Run managed UI validation', kind: 'action' },
  { value: 'tool-settings:read', label: 'Tool settings', kind: 'read' },
  { value: 'tool-settings:write', label: 'Edit tool settings', kind: 'action' },
  { value: 'merge_requests:write', label: 'Merge requests', kind: 'action' },
  { value: 'conversations:create', label: 'Create conversations', kind: 'action' },
  { value: 'conversations:messages:write', label: 'Send conversation messages', kind: 'action' },
  { value: 'attachments:write', label: 'Attach files', kind: 'read' },
  { value: 'sessions:register', label: 'Local CLI sessions', kind: 'read' }
];

export const DEFAULT_TOOL_SCOPES = TOOL_SCOPES.filter((scope) => scope.kind === 'read' || scope.kind === 'coordination').map(
  (scope) => scope.value
);
